/**
 * Adds affiliate parameters to platform links
 */

const BEATPORT_AFFILIATE_PARAMS = "a_aid=68e7bd84c17c4";

/**
 * Adds Beatport affiliate parameters to the URL if it's a Beatport link
 * @param url - The URL to potentially add affiliate parameters to
 * @param platform - The platform type
 * @returns The URL with affiliate parameters if it's Beatport, otherwise the original URL
 */
export function addAffiliateParams(url: string, platform: string): string {
  // Only add affiliate params to Beatport links
  if (platform !== "beatport") {
    return url;
  }

  try {
    const urlObj = new URL(url);

    // Add affiliate parameters
    const separator = urlObj.search ? "&" : "?";
    return `${url}${separator}${BEATPORT_AFFILIATE_PARAMS}`;
  } catch (error) {
    // If URL parsing fails, fallback to simple concatenation
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}${BEATPORT_AFFILIATE_PARAMS}`;
  }
}
